import AsyncStorage from '@react-native-async-storage/async-storage';
import { DateTime } from 'luxon';
import { API } from '../../service/api';
import { CompanyActions } from '../reducers/companyReducer';

export const login = (userData, navigation) => (dispatch) => {
  dispatch({ type: CompanyActions.TOGGLE_LOADER });
  API.post('/auth', {
    email: userData.email,
    senha: userData.pass,
    perfil: 'EMPRESA',
  }).then(({ data }) => {
    if (data.success) {
      const { id_plano, id_empresa } = data.data;
      AsyncStorage.setItem('PROFILE', 'EMPRESA');
      AsyncStorage.setItem('ID', id_empresa);
      dispatch({ type: CompanyActions.UPDATE_DATA, dataType: 'companyData', dataValue: data.data });
      dispatch({ type: CompanyActions.UPDATE_DATA, dataType: 'isError', dataValue: false });
      dispatch(getPlanData(id_plano, navigation));
    }
  }).catch(() => {
    dispatch({ type: CompanyActions.TOGGLE_ERROR });
  }).finally(() => {
    dispatch({ type: CompanyActions.TOGGLE_LOADER });
  });
};

export const getPlanData = (id_plano, navigation) => (dispatch) => {
  API.get(`/get/plano/${id_plano}`).then(({ data }) => {
    dispatch({ type: CompanyActions.UPDATE_DATA, dataType: 'planData', dataValue: data.data[0] });
    navigation.navigate('Profile Company');
  });
};

export const getPNFAM = (id_empresa) => async (dispatch) => {
  API.post('/search/relatorio_pnfam/', {
    where: `id_empresa = '${id_empresa}'`,
  }).then(({ data: response }) => {
    const { success, data } = response;
    if (success && data.length > 0) {
      dispatch({ type: CompanyActions.UPDATE_DATA, dataType: 'pnfamData', dataValue: data[0] });
    }
  }).catch((error) => {
    console.log(error.response.data.error);
  });
};

export const getClassSummary = (id_empresa) => async (dispatch) => {
  API.post('/search/colaborador_aula/', {
    where: `id_colaborador in (SELECT id_colaborador FROM colaborador WHERE id_empresa = '${id_empresa}')`,
  }).then(({ data: workerResponse }) => {
    const { data } = workerResponse;
    const workerMean = {
      nota_aula: 0,
      nota_profissional: 0,
    };
    if (data.length > 0) {
      workerMean.nota_aula = data.reduce((p, c) => ({ nota_aula: p.nota_aula + c.nota_aula })).nota_aula / data.length;
      workerMean.nota_profissional = data.reduce((p, c) => ({ nota_profissional: p.nota_profissional + c.nota_profissional })).nota_profissional / data.length;
    }
    API.post('/search/profissional_aula/', {
      where: `id_profissional in (SELECT id_profissional FROM empresa WHERE id_empresa = '${id_empresa}')`,
    }).then(({ data: trainerResponse }) => {
      const { data: trainerData } = trainerResponse;
      const trainerMean = {
        nota_dificuldade: 0,
        nota_qualidade: 0,
      };
      if (trainerData.length > 0) {
        trainerMean.nota_dificuldade = trainerData.reduce((p, c) => ({ nota_dificuldade: p.nota_dificuldade + c.nota_dificuldade })).nota_dificuldade / trainerData.length;
        trainerMean.nota_qualidade = trainerData.reduce((p, c) => ({ nota_qualidade: p.nota_qualidade + c.nota_qualidade })).nota_qualidade / trainerData.length;
      }
      dispatch({ type: CompanyActions.UPDATE_DATA, dataType: 'classSummary', dataValue: { ...workerMean, ...trainerMean } });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
  }).catch((error) => {
    console.log(error.response.data.error);
  });
};

export const sendForgotEmail = (email, perfil) => () => {
  API.post('/resetpwd', { email, perfil }).then().catch((error) => {
    console.log(error.response.data.error);
  });
};

export const getPlans = () => (dispatch) => {
  API.post('/search/plano', { where: 'cd_tipo = "EMPRESA"' }).then(({ data: response }) => {
    const { data } = response;
    if (data.length > 0) {
      dispatch({ type: CompanyActions.SET_AVAILABLE_PLANS, availablePlans: data });
    }
  }).catch((error) => {
    console.log(error.response.data.error);
  });
};

export const confirmSubscription = (companyData, navigation) => (dispatch) => {
  API.post('/create/empresa', { ...companyData, cd_status: 'LEAD', data_contratacao: DateTime.now().toFormat('yyyy-LL-dd') })
    .then((resp) => {
      if (resp.data.success) {
        navigation.navigate('Confirmed Subscription');
      }
    });
};
